export default __webpack_public_path__ + "static/media/No44.65bb9023.jpg";